
let STAGE;
let REGION;
let STACK;
let VERB;

class Stack {
  static setStack(stack) {
    Stack.stack = stack;
  }
}
Stack.stack = "";

class Stage {
  static setStage(stage) {
    Stage.stage = stage;
  }
}
Stage.stage = "";

class Region {
  static setRegion(region) {
    Region.region = region;
  }
}
Region.region = "";


if (process.env.CA_ENV_DEBUG) {
  VERB = !!process.env.CA_ENV_DEBUG;
}

// If the CA_STAGE|CA_REGION|CA_STACK environment variables
// initialize these.

if (process.env.CA_STAGE) {
  STAGE = process.env.CA_STAGE;
  Stage.setStage(STAGE);
}

if (process.env.CA_REGION) {
  REGION = process.env.CA_REGION;
  Region.setRegion(REGION);
}

if (process.env.CA_STACK) {
  STACK = process.env.CA_STACK;
  Stack.setStack(STACK);
}

// Deprecated, use static class instance
const SetStage = stage => {
  console.log("SetStage deprecated");
  STAGE = stage;
  Stage.setStage(stage);
}

const GetStage = () => {
  return Stage.stage;
}

const IsProd = () => {
  return GetStage() === "prod";
}

const GetRegion = () => {
  return Region.region;
}

const SetRegion = region => {
  console.log("SetRegion deprecated");
  REGION = region;
  Region.region = region;
  if (VERB) {
    console.log("Setting region", REGION);
  }
}

const SetStack = stack => {
  console.log("SetStack deprecated");
  STACK = stack;
  Stack.stack = stack;
}

const GetStack = () => {
  return Stack.stack;
}

module.exports = {
  GetStage, SetStage, IsProd, GetRegion, SetRegion, SetStack, GetStack,
  Stack, Stage, Region,
}